import axios from "axios";
export var AuthApi;
(function (AuthApi) {
    const origin = `${process.env.API_HOST}public/auth/v1/`;
    async function postGoogleAuth(googleToken) {
        const token = await (await axios.post(`${origin}google`, googleToken)).data;
        return token;
    }
    AuthApi.postGoogleAuth = postGoogleAuth;
    async function getRefreshToken(token) {
        const newToken = await (await axios.get(`${origin}refresh`, { headers: { Authorization: `Bearer ${token}` } })).data;
        return newToken;
    }
    AuthApi.getRefreshToken = getRefreshToken;
    async function getSubscriptionInfo(token) {
        const response = await axios.get(`${origin}account/infinitex-plus/info`, { headers: { Authorization: `Bearer ${token}` } });
        return response.data;
    }
    AuthApi.getSubscriptionInfo = getSubscriptionInfo;
})(AuthApi || (AuthApi = {}));
